import * as React from 'react';

import { cn } from '@/utils/utils_client';

export const UI_PTIMITIVE__card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('rounded-lg border bg-card text-card-foreground shadow-sm', className)} {...props} />
));
UI_PTIMITIVE__card.displayName = 'Card';
